import { render, staticRenderFns } from "./SendMessageBar.vue?vue&type=template&id=02f88c78&scoped=true"
import script from "./SendMessageBar.vue?vue&type=script&lang=js"
export * from "./SendMessageBar.vue?vue&type=script&lang=js"
import style0 from "./SendMessageBar.vue?vue&type=style&index=0&id=02f88c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f88c78",
  null
  
)

export default component.exports